import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { LocalePicker } from './locale-picker.comp';
import { getBaseReactDriver } from '../../common/base-driver';
import { findInPopover } from '../../common/find-in-popover';
import { createLegacyFloaterMenuDriver } from '../floater-menu/floater-menu.legacy-driver';
// tslint:disable-next-line:max-line-length
export var createLegacyLocalePickerDriver = function (elemOrBaseDriver) {
    var base = getBaseReactDriver(elemOrBaseDriver);
    return {
        getPickedLocaleText: function () { return base.find('.picked-locale').getText(); },
        getPickedLocale: function () { return base.find('.picked-locale').getDataAttr('value'); },
        pickLocale: function (locale) {
            base.find('.deprecated-link-button').click();
            var elem = findInPopover(".locale-menu-wrapper").elem;
            if (elem) {
                createLegacyFloaterMenuDriver(elem).selectByValue(locale);
            }
        },
        base: base,
    };
};
export var renderLegacyLocalePickerAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(LocalePicker, __assign({}, props)));
    return createLegacyLocalePickerDriver(elem);
};
//# sourceMappingURL=locale-picker.legacy-driver.js.map